import { all, takeLatest } from 'redux-saga/effects'
import * as coreSagas from '../../../core/duck/operations'
import * as coreActionTypes from '../../../core/duck/types'
import * as viewsSagas from '../../../views/duck/operations'
import * as viewsActionTypes from '../../../views/duck/types'
export default function* rootSaga() {
  yield all([
    takeLatest(coreActionTypes.LOAD_DATA, coreSagas.checkAndGetData),
    takeLatest(viewsActionTypes.USER_SELECT_CLASS, coreSagas.showSnackbar),
    takeLatest(
      viewsActionTypes.USER_DESELECT_CLASS,
      viewsSagas.onClassDeleteHandler
    ),
    takeLatest(viewsActionTypes.USER_DESELECT_CLASS, coreSagas.showSnackbar),
    takeLatest(viewsActionTypes.USER_ADD_BUSINESS_LINE, coreSagas.showSnackbar),
    takeLatest(
      viewsActionTypes.USER_ADD_BUSINESS_LINE_RECOMMENDATION,
      viewsSagas.handleBusinesslineRecommendationAdd
    ),
    takeLatest(
      viewsActionTypes.USER_REMOVE_BUSINESS_LINE,
      viewsSagas.onBusinessLineDeleteHandler
    ),
    takeLatest(
      viewsActionTypes.USER_REMOVE_BUSINESS_LINE,
      coreSagas.showSnackbar
    ),
    takeLatest(
      [
        viewsActionTypes.USER_SELECT_FACTOID,
        viewsActionTypes.USER_DESELECT_FACTOID
      ],
      viewsSagas.generateBusinessLineSelections
    ),
    takeLatest(
      [
        viewsActionTypes.USER_SELECT_FACTOID,
        viewsActionTypes.USER_DESELECT_FACTOID
      ],
      coreSagas.showSnackbar
    ),
    takeLatest([viewsActionTypes.USER_SELECT_FACTOID,
      viewsActionTypes.USER_DESELECT_FACTOID, viewsActionTypes.USER_SELECT_CLASS,
      viewsActionTypes.USER_DESELECT_CLASS,
      viewsActionTypes.USER_ADD_BUSINESS_LINE,
      viewsActionTypes.USER_REMOVE_BUSINESS_LINE],
      coreSagas.saveJourney
    )
  ])
}



// WEBPACK FOOTER //
// ./src/core/store/sagas/index.ts